export default __webpack_public_path__ + "static/media/no_triggers.72c3dce3.svg";